import { useEffect, useMemo, useState } from 'react'
import { Link } from "react-router-dom"
import { Table, Select, Input, Button, Space, DatePicker, Modal, Form, Radio } from 'antd'
import { RadioChangeEvent } from "antd/lib/radio/interface"
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { baseAxiosNoInfo, baseAxiosComplete, axiosTable } from '../../tool/axios'
import { SelectStores } from '../../component/common/Selects'
import { SelectSingleProjectTypes } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import moment from 'moment'
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 12 }
}

type pagination = {
  current: number,
  pageSize: number,
  total: number,
}

type fetchParams = {
  store_id: string | undefined,
  customer_name: string | undefined,
  customer_phone: string | undefined,
  item_name: string | undefined,
  item_type_id: string | undefined,
  item_coperation_id: string | undefined,
  employee_id_adviser: string | undefined,
  employee_id_recover: string | undefined,
  date: any,
  review_status: string | undefined
}

export default function CkCollectionList() {

  let otherParamsTml = {
    store_id: undefined,
    customer_name: undefined,
    customer_phone: undefined,
    item_name: undefined,
    item_type_id: undefined,
    item_coperation_id: undefined,
    employee_id_adviser: undefined,
    employee_id_recover: undefined,
    date: undefined,
    review_status: undefined
  }

  let paginatioTml = {
    current: 1,
    pageSize: 10,
    total: 0
  }

  const [initDate, setInitDate] = useState<boolean>(true)

  const [otherParams, setOtherParams] = useState<fetchParams>(otherParamsTml)
  const [pagination, setPagination] = useState<pagination>(paginatioTml)

  const [tableList, setTableList] = useState<any[]>([])

  const [coperationList, setCoperationList] = useState<any[]>([])
  const [adviseEmployeeList, setAdviseEmployeeList] = useState<any[]>([])
  const [recoverEmployeeList, setRecoverEmployeeList] = useState<any[]>([])

  const getCoperationList = coperationList.map((el: any) => (<Option value={el.coperation_id} key={el.coperation_id}  >{el.coperation_name}</Option>))
  const getAdviseEmployeeList = adviseEmployeeList.map((el: any) => (<Option value={el.employee_id} key={el.employee_id}  >{el.user_name}</Option>))
  const getRecoverEmployeeList = recoverEmployeeList.map((el: any) => (<Option value={el.employee_id} key={el.employee_id}  >{el.user_name}</Option>))

  const [confrimMoneyVisible, setConfrimMoneyVisible] = useState<boolean>(false)
  const [activeRecord, setActiveRecord] = useState<{ id: string } | undefined>()

  const [form] = Form.useForm()
  const [passType, setPassType] = useState<number | undefined>(undefined)

  const permission: string[] = useMemo(() => {
    return getPermission()
  }, [window.location.pathname])

  useEffect(() => {
    // 获取产康合作商
    baseAxiosNoInfo.get('/chankang_center/coperation/select_list').then((response: any) => {
      setCoperationList(response)
    })

    if (initDate) {
      var startDate = moment().startOf('month');
      var endDate = moment().endOf('month');
      // 初始化创建日期
      otherParams.date = [startDate, endDate];

      setInitDate(false)
    }

    fetch({ pagination, otherParams })
  }, [pagination.current])

  const getEmployeeList = (type: any, id: any) => {
    // 查询员工列表，包括：产康师、产康顾问
    baseAxiosNoInfo('/global/employee_list_by_position', { params: { position_number: type, department_id: id } }).then((res: any) => {
      if (res) {
        if (type == 4) {
          setAdviseEmployeeList(res)

        } else {
          setRecoverEmployeeList(res)
        }
      }
    })
  }

  const handleInputChange = (value: string, attr: string) => {
    let params: any = _.cloneDeep(otherParams)
    params[attr] = value

    setOtherParams(params)
  }

  const handleSelectChange = (value: string, attr: string) => {
    if (attr == 'store_id') {
      getEmployeeList(4, value)
      getEmployeeList(5, value)
    }

    let params: any = _.cloneDeep(otherParams)
    params[attr] = value

    setOtherParams(params)
  }

  const handleDateChange = (value: any, attr: any) => {
    let params: any = _.cloneDeep(otherParams)
    params[attr] = value

    setOtherParams(params)
  }

  const handleSearch = () => {
    let p: any = { ...pagination }
    p.current = 1
    setPagination(p)

    fetch({ pagination: p, otherParams })
  }

  const handleTableChange = (antPagination: any) => {
    const p = { ...pagination }
    p.current = antPagination.current

    setPagination(p)
  }

  const fetch = ({ pagination, otherParams }: { pagination: Object, otherParams: object }) => {
    setTableList([])

    const iPagination: any = { ...pagination }
    iPagination.page_num = iPagination.current
    iPagination.page_size = iPagination.pageSize

    delete iPagination.current
    delete iPagination.pageSize
    delete iPagination.total

    let params: any = { ...otherParams }
    if (params.date) {
      params.create_start_date = params.date[0].format('YYYY-MM-DD')
      params.create_end_date = params.date[1].format('YYYY-MM-DD')

      delete params.date
    }

    axiosTable.get('/finance_center/chankang/refund_records/page_list', {
      params: {
        ...iPagination,
        ...params
      }

    }).then((response: any) => {
      if (response) {
        let p: any = { ...pagination }
        p.total = response.total

        setPagination(p)
        setTableList(response.records)
      }
    })
  }

  const resetForm = () => {
    // 清空初始数据
    setAdviseEmployeeList([]);
    setRecoverEmployeeList([]);

    setInitDate(false)
    setOtherParams(otherParamsTml)

    let p: any = { ...pagination }
    p.current = 1
    setPagination(p)

    fetch({ pagination: p, otherParams: otherParamsTml })
  }

  const exportExcel = () => {
    const iPagination: any = { ...pagination }
    iPagination.page_num = iPagination.current
    iPagination.page_size = iPagination.pageSize

    delete iPagination.current
    delete iPagination.pageSize
    delete iPagination.total

    let params: any = { ...otherParams }

    if (params.date) {
      params.create_start_date = params.date[0].format('YYYY-MM-DD')
      params.create_end_date = params.date[1].format('YYYY-MM-DD')

      delete params.date
    }

    baseAxiosComplete('/finance_center/chankang/refund_records/excel', {
      params: {
        ...iPagination,
        ...params
      }

    }).then(res => {
      if (res.status === 0) {
        window.open(res.data)
      }
    })
  }

  // 审核
  const onFinish = (value: any) => {
    baseAxiosComplete.post('/finance_center/chankang/refund_records/review', {
      refund_id: activeRecord?.id,
      review_status: value.review_status,
      review_refuse_reason: value.review_refuse_reason

    }).then((res: any) => {
      if (res.status === 0) {
        fetch({ pagination, otherParams })
        setConfrimMoneyVisible(false)
      }
    })
  }

  const handlePassChange = (e: RadioChangeEvent) => {
    setPassType(e.target.value)
  }

  return <div className="common-page">
    {/* 财务中心 -> 财务管理 -> 产康退款管理 */}
    <BreadCrumb position={['财务中心', '产康退款管理']} />

    <div className="common-top-form">
      <Space direction="horizontal" wrap>
        <div style={{ marginRight: 8, marginBottom: 12 }}>
          <SelectStores valueProp="id" value={otherParams.store_id} onChange={(value: string) => { handleSelectChange(value, 'store_id') }} />
        </div>

        <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} value={otherParams.customer_name} placeholder="客户姓名" onChange={(e: { target: { value: string } }) => { handleInputChange(e.target.value, 'customer_name') }} />
        <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} value={otherParams.customer_phone} placeholder="联系方式" onChange={(e: { target: { value: string } }) => { handleInputChange(e.target.value, 'customer_phone') }} />

        <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} value={otherParams.item_name} placeholder="项目名称" onChange={(e: { target: { value: string } }) => { handleInputChange(e.target.value, 'item_name') }} />
        <div className="fl" style={{ marginRight: 8, marginBottom: 12 }}>
          <SelectSingleProjectTypes value={otherParams.item_type_id} onChange={(value: string) => { handleSelectChange(value, 'item_type_id') }} />
        </div>
        <Select className="fl" style={{ marginRight: 8, marginBottom: 12, width: 180 }} value={otherParams.item_coperation_id} onChange={(value: string) => { handleSelectChange(value, 'item_coperation_id') }} placeholder="项目合作商">
          {getCoperationList}
        </Select>

        <Select className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} value={otherParams.employee_id_adviser} onChange={(value: string) => { handleSelectChange(value, 'employee_id_adviser') }} placeholder="产康顾问">
          {getAdviseEmployeeList}
        </Select>
        <Select className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} value={otherParams.employee_id_recover} onChange={(value: string) => { handleSelectChange(value, 'employee_id_recover') }} placeholder="产康师">
          {getRecoverEmployeeList}
        </Select>

        <RangePicker className="fl" style={{ marginRight: 8, marginBottom: 12, width: 250 }} value={otherParams.date} placeholder={['创建开始日期', '创建结束日期']} onChange={(el: any) => (handleDateChange(el, 'date'))} />
        <Select className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} value={otherParams.review_status} onChange={(value: string) => { handleSelectChange(value, 'review_status') }} placeholder="审核状态" >
          <Option value="0">待审核</Option>
          <Option value="1">审核通过</Option>
          <Option value="2">审核未通过</Option>
        </Select>
      </Space>

      <div style={{ marginTop: 10 }}>
        {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
        <Button style={{ marginRight: 12, marginBottom: 12 }} icon={<RedoOutlined />} onClick={resetForm}>重置</Button>
        {permission.includes('导出') && <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { exportExcel() }} type="dashed">导出</Button>}
      </div>
    </div>

    <div className="common-main">
      <Table dataSource={tableList} bordered={true} scroll={{ x: 'max-content' }} rowKey="order_id" pagination={pagination} onChange={handleTableChange}>
        <Column title="门店" dataIndex="store_name" key="store_name" />

        <Column
          title="客户姓名"
          key="action"
          render={(text, record: any) => (
            <Space size="middle">
              <Button type="link"><Link to={"/ck_customer_detail/" + record.customer_id}>{record.customer_name}</Link></Button>
            </Space>
          )}
        />

        <Column title="手机号" dataIndex="customer_phone" key="customer_phone" />
        <Column title="项目名称" dataIndex="item_name" key="item_name" />
        <Column title="项目分类" dataIndex="item_type_name" key="item_type_name" />
        <Column title="项目来源" dataIndex="item_in_out_desc" key="item_in_out_desc" />
        <Column title="项目合作商" dataIndex="item_coperation_name" key="item_coperation_name" />
        <Column title="次数" dataIndex="refund_count" key="refund_count" />
        <Column title="退款金额" dataIndex="refund_amount" key="refund_amount" />
        <Column title="产康顾问" dataIndex="employee_name_adviser" key="employee_name_adviser" />
        <Column title="产康师" dataIndex="employee_name_recover" key="employee_name_recover" />
        <Column title="创建人" dataIndex="create_user_name" key="create_user_name" />
        <Column title="创建时间" dataIndex="create_time" key="create_time" />

        <Column title="审核状态" dataIndex="review_status_desc" key="review_status_desc" />
        <Column title="审核人" dataIndex="review_user_name" key="review_user_name" />
        <Column title="审核时间" dataIndex="review_time" key="review_time" />
        <Column title="不通过原因" dataIndex="review_refuse_reason" key="review_refuse_reason" />

        <Column
          title="操作"
          key="action"
          render={(text, record: any) => {
            return (<Space size="middle">
              {record.review_status === 0 && permission.includes('审核') && <Button onClick={() => {
                form.setFieldsValue({
                  review_status: undefined,
                  review_refuse_reason: undefined,
                })

                setPassType(undefined)
                setConfrimMoneyVisible(true)
                setActiveRecord({ id: record.refund_id })
              }}>审核</Button>}
            </Space>)
          }}
        />
      </Table>
    </div>

    {/* 审核弹窗 */}
    <Modal title="退款审核" visible={confrimMoneyVisible} footer={false} onCancel={() => { setConfrimMoneyVisible(false) }}>
      <Form {...formItemLayout} form={form} onFinish={onFinish} >
        <Form.Item label="是否通过" name="review_status" rules={[{ required: true, message: '必须选择是否通过审核' }]}>
          <Radio.Group onChange={handlePassChange} value={passType}>
            <Radio value={1}>通过</Radio>
            <Radio value={2}>不通过</Radio>
          </Radio.Group>
        </Form.Item>

        {passType === 2 && <Form.Item label="备注" name="review_refuse_reason" rules={[{ required: true, message: '必须填写备注' }]}>
          <Input />
        </Form.Item>}

        <Form.Item wrapperCol={{ span: 12, offset: 6 }}>
          <Button type="primary" htmlType="submit">提交</Button>
        </Form.Item>
      </Form>
    </Modal>
  </div>
}